module.exports = __webpack_public_path__ + "static/HOME1-55c99617faa434eea5902c2111f48543.png";